import React from 'react';
import { slide as Menu } from 'react-burger-menu';
import { NavLink } from "react-router-dom";
import application_contants from '../../constants/application_contant';



function Sidebar() {
    return (
      <div className="sidebar1 pt-5">

<div className="p-very-small  align-center pt-5">
<div classname="home1-icon p-very-small">
<NavLink to="/Home"  activeClassName="active-icon">
  <img src={application_contants.sidebarIcon} alt="Home-icon" className="icon-img" style={{ width: '24px', height: '26px',  marginBottom: '10px' }}/>
  Home
  </NavLink>
  </div>
  <div classname="home1-icon " >
  <NavLink to="/Patients" activeClassName="active-icon">
  <img src={application_contants.sidebarIcon} alt="Home Icon" className="icon-img" style={{ width: '24px', height: '26px', marginBottom: '10px' }} />
  Patients</NavLink>
  </div>
  <div>
  <NavLink to="/Test" activeClassName="active-icon">
  <img src={application_contants.sidebarIcon} alt="Home Icon" className="icon-img" style={{ width: '24px', height: '26px', marginBottom: '10px' }}  />
  Visits</NavLink>
  <NavLink to="./Hospital" activeClassName="active-icon">
  <img src={application_contants.sidebarIcon} alt="Home Icon" className="icon-img" style={{ width: '24px', height: '26px', marginBottom: '10px' }} />
  Hospitals</NavLink>
  </div>
  <div>
  <NavLink to="/Devices" activeClassName="active-icon">
  <img src={application_contants.sidebarIcon} alt="Home Icon" className="icon-img" style={{ width: '24px', height: '26px', marginBottom: '10px' }} /> 
  <span className="p-very-small align-center">Devices</span>
  </NavLink>
</div>
<div>
  <NavLink to="/users" activeClassName="active-icon">
  <img src={application_contants.sidebarIcon} alt="Home Icon" className="icon-img" style={{ width: '24px', height: '26px', marginBottom: '10px' }} /> 
  <span className="p-very-small align-center">Users</span>
  </NavLink>
</div>
   </div>   
      
      </div>
    );
  }

export default Sidebar;